export default __webpack_public_path__ + "static/media/blue-add-to-board-icon.1ef72592.svg";